'use client';
import { AppLayoutContext } from '#pplx/frontend/apps/ask/layout/primitives/AppLayoutContext.js';
import { useContext } from 'react';
export const useAppLayout = () => {
    const context = useContext(AppLayoutContext);
    if (!context) {
        throw new Error('useAppLayout must be used within an AppLayoutProvider');
    }
    return context;
};
//# sourceMappingURL=AppLayoutContextSupport.js.map